module.exports = __webpack_public_path__ + "static/media/teenpatti.88e1f023.jpeg";